import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const Navdata = () => {
  const history = useNavigate();

  // State variables for menu items
  const [isDashboard, setIsDashboard] = useState(false);
  const [isClients, setIsClients] = useState(false);
  const [isDemo1, setIsDemo1] = useState(false);
  const [isDemo2, setIsDemo2] = useState(false);
  const [isDemo3, setIsDemo3] = useState(false);
  const [isChat, setIsChat] = useState(false);
  const [isChatbot, setIsChatbot] = useState(false);
  const [isAnalysis, setIsAnalysis] = useState(false);
  const [iscurrentState, setIscurrentState] = useState("Dashboard");

  function updateIconSidebar(e) {
    if (e && e.target && e.target.getAttribute("subitems")) {
      const ul = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("subitems");
        if (document.getElementById(id))
          document.getElementById(id).classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
    if (iscurrentState !== "Dashboard") {
      setIsDashboard(false);
    }
    if (iscurrentState !== "Clients") {
      setIsClients(false);
    }
    if (iscurrentState !== "Demo1") {
      setIsDemo1(false);
    }
    if (iscurrentState !== "Demo2") {
      setIsDemo2(false);
    }
    if (iscurrentState !== "Demo3") {
      setIsDemo3(false);
    }
    if (iscurrentState !== "Chat") {
      setIsChat(false);
    }
    if (iscurrentState !== "Chatbot") {
      setIsChatbot(false);
    }
    if (iscurrentState !== "Analysis") {
      setIsAnalysis(false);
    }
  }, [
    history,
    iscurrentState,
    isDashboard,
    isClients,
    isDemo1,
    isDemo2,
    isDemo3,
    isChat,
    isChatbot,
    isAnalysis,
  ]);

  const menuItems = [
    {
      label: "Menu",
      isHeader: true,
    },
    {
      id: "dashboard",
      label: "Dashboard",
      icon: "bx bxs-dashboard",
      link: "/dashboard",
      stateVariables: isDashboard,
      click: function (e) {
        e.preventDefault();
        setIsDashboard(!isDashboard);
        setIscurrentState("Dashboard");
        updateIconSidebar(e);
      },
    },
    // {
    //   id: "clients",
    //   label: "Clients",
    //   icon: "bx bx-group",
    //   link: "/clients",
    //   stateVariables: isClients,
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsClients(!isClients);
    //     setIscurrentState("Clients");
    //     updateIconSidebar(e);
    //   },
    // },
    {
      id: "demo1",
      label: "Document Scanner",
      icon: "ri-file-pdf-2-line",
      link: "/document-scanner",
      stateVariables: isDemo1,
      click: function (e) {
        e.preventDefault();
        setIsDemo1(!isDemo1);
        setIscurrentState("Demo1");
        updateIconSidebar(e);
      },
    },
    {
      id: "demo3",
      label: "Call Analyzer",
      icon: "ri-phone-line",
      link: "/call-analyzer",
      stateVariables: isDemo3,
      click: function (e) {
        e.preventDefault();
        setIsDemo3(!isDemo3);
        setIscurrentState("Demo3");
        updateIconSidebar(e);
      },
    },
    {
      id: "demo2",
      label: "Invoice Scanner",
      icon: "ri-bill-line",
      link: "/invoice-scanner",
      stateVariables: isDemo2,
      click: function (e) {
        e.preventDefault();
        setIsDemo2(!isDemo2);
        setIscurrentState("Demo2");
        updateIconSidebar(e);
      },
    },
    {
      id: "chat",
      label: "Warehouse Bot",
      icon: "ri-message-2-line",
      link: "/chat",
      stateVariables: isChat,
      click: function (e) {
        e.preventDefault();
        setIsChat(!isChat);
        setIscurrentState("Chat");
        updateIconSidebar(e);
      },
    },
    {
      id: "chatbot",
      label: "Maintenance Bot",
      icon: "ri-robot-line",
      link: "/chatbot",
      stateVariables: isChatbot,
      click: function (e) {
        e.preventDefault();
        setIsChatbot(!isChatbot);
        setIscurrentState("Chatbot");
        updateIconSidebar(e);
      },
    },
    {
      id: "analysis-prediction",
      label: "Analysis & Prediction",
      icon: "ri-line-chart-line",
      link: "/analysis-prediction",
      stateVariables: isAnalysis,
      click: function (e) {
        e.preventDefault();
        setIsAnalysis(!isAnalysis);
        setIscurrentState("Analysis");
        updateIconSidebar(e);
      },
    }
    //   link: "/#",
    //   click: function (e) {
    //     e.preventDefault();
    //     setIsSales( !isSales);
    //     setIscurrentState("Sales");
    //     updateIconSidebar(e);
    //   },
    //   stateVariables: isSales,
    //   subItems: [ 
    //     {
    //       id: "prospect",
    //       label: "Prospect",
    //       link: "/prospect",
    //       parentId: "sales",
    //       // badgeName: "New",
    //       // badgeColor: "danger"
    //     },
    //   ],
    // },


  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
